import { ThemeProvider } from '@infotech-soe/erp-ui-kit';
import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../store/reducers/root';
import { getCurrentTheme } from '../../store/selectors/theme';

export default connect((state: AppState) => ({
  theme: getCurrentTheme(state),
}))(ThemeProvider);
